import OptionSearch from "../../components/organisms/OptionSearch";
function Search() {
  return <OptionSearch />;
}
export default Search;